import React from "react";

export const Icon = () => <i className="fa fa-spinner fa-spin "></i>;

export const Content = () => (
  <div
    className="text-center"
    style={{
      width: "100%"
    }}
  >
    <Icon />
  </div>
);
